import { render } from "./ClientUpdate.vue?vue&type=template&id=ec6fa4ec"
import script from "./ClientUpdate.vue?vue&type=script&lang=js"
export * from "./ClientUpdate.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__